import { PropertyValueSet } from "@genesys/property";
import { OperatingCaseGroupEnum } from "../../../graphql-types";

export interface SettingsOverrides {
  readonly [OperatingCaseGroupEnum.JANUARY]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.FEBRUARY]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.MARCH]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.APRIL]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.MAY]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.JUNE]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.JULY]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.AUGUST]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.SEPTEMBER]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.OCTOBER]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.NOVEMBER]: PropertyValueSet.PropertyValueSet;
  readonly [OperatingCaseGroupEnum.DECEMBER]: PropertyValueSet.PropertyValueSet;
}
